import React from "react";

import { ChartCollectionData } from "../../../../models/ChartCollectionData";
import { ChartButton } from "../../../Common/ChartButton";
import { useIndividualFacilityChart } from "../hooks/useIndividualFacilityChart";

import "./styles.scss";

export interface IFacilityDetailsAnalysisChartSelectProps {
  chartCollections: ChartCollectionData[];
  selectedChartIndex: number;
  onSelectChart: (chartId: number) => void;
  showDropdown?: boolean;
  showDescription?: boolean;
}

export const FacilityDetailsAnalysisChartSelect: React.FunctionComponent<
  IFacilityDetailsAnalysisChartSelectProps
> = (props) => {
  const {
    selectedChartIndex,
    onSelectChart,
    chartCollections,
    showDropdown = true,
    showDescription = true,
  } = props;

  const selectedChartId = chartCollections[selectedChartIndex]?.id;
  const { data: selectedChartData } =
    useIndividualFacilityChart(selectedChartId);

  const handleClick = (index: number) => {
    onSelectChart(index);
  };

  return (
    <div className="chart-select-container">
      {showDropdown && (
        <div className="chart-select-row">
          {chartCollections?.map((item, index) => (
            <ChartButton
              key={item.id}
              onClick={() => handleClick(index)}
              chartCollectionData={item}
              isActive={selectedChartIndex === index}
            />
          ))}
        </div>
      )}
      {showDescription && selectedChartData?.description && (
        <div className="chart-description-row">
          <div className="chart-description">
            {selectedChartData.description}
          </div>
        </div>
      )}
    </div>
  );
};
